import { useMutation, useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { apiScoping } from '@/lib/api/scoping'
import { installationPhaseKeys } from '@/features/plant-assessment/api/query-keys'

export type CreateInstallationPhaseInput = {
  plantAssessmentId: string
  // Omitted (multiPhase flag): the API names the phase "Pilot", then "Expansion N".
  name?: string
  targetDate?: string
  hubspotDealId?: string
}

const CreateInstallationPhaseResponseSchema = z.object({
  result: z.object({ id: z.string() })
})

async function createInstallationPhase(input: CreateInstallationPhaseInput): Promise<string> {
  const res = await apiScoping.post('/api/v1/installation-phase', input)
  const result = CreateInstallationPhaseResponseSchema.safeParse(res.data)
  if (!result.success) {
    console.error(
      '[installation-phase-create] Zod parse failed - raw response:',
      res.data,
      'issues:',
      result.error.issues
    )
    throw result.error
  }
  return result.data.result.id
}

export function useCreateInstallationPhase() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createInstallationPhase,
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: installationPhaseKeys.list(variables.plantAssessmentId)
      })
    }
  })
}
